/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var UploadCloudOutlineIcon = function UploadCloudOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M12 3C15.64 3 18.67 5.59 19.35 9.04C21.95 9.22 24 11.36 24 14C24 16.76 21.76 19 19 19H16V17H19C20.66 17 22 15.66 22 14C22 12.34 20.66 11 19 11H17.5V10.5C17.5 7.46 15.04 5 12 5C9.48 5 7.37 6.69 6.71 9H6C3.79 9 2 10.79 2 13C2 15.21 3.79 17 6 17H8V19H6C2.69 19 0 16.31 0 13C0 9.91 2.34 7.36 5.35 7.04C6.6 4.64 9.11 3 12 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21V12.7782L15.1109 14.8891L16.5251 13.4749L11.8787 8.82842L7.35358 13.3535L8.76779 14.7677L11 12.5355V21H13Z"
  }));
};
export default UploadCloudOutlineIcon;